import axios from "axios";

export let apiurl = axios.create({
  baseURL: "https://api.vanshitex.com",
  withCredentials: true,
});
